import type { EMediaCollection } from '@/data/media'

const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS, ApiDataModel.MEDIA)

export const apiGadgetsMedia = {
	fetchGadgetsMedia: async (collection: EMediaCollection) => {
		const { data } = await apiCommon<IMedia[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(undefined, { collection_name: collection }),
		})

		return data.map(Media)
	},
	storeGadgetsMedia: async (files: IFile[], collection: EMediaCollection, modelId: string | number) => {
		const payload = FilesToMediaPayload(files, collection, modelId)

		const { data } = await apiCommon<IMedia[]>(`${groupPrefix}`, { method: 'POST', body: payload }, 'pl', true)

		return data.map(Media)
	},
	storeGadgetsMediaBulk: async (collectionOfFiles: Record<number, IFile[]>, collection: EMediaCollection) => {
		const payload = FilesToMediaBulkPayload(collectionOfFiles, collection)

		const { data } = await apiCommon<IMedia[]>(`${groupPrefix}`, { method: 'POST', body: payload }, 'pl', true)

		return data.map(Media)
	},
	reorderGadgetsMedia: async (mediaUuids: string[]) => {
		await apiCommon(`${groupPrefix}/order`, { method: 'PUT', body: { order: mediaUuids } })
	},
	destroyGadgetsMedia: async (mediaUuids: string[]) => {
		await apiCommon(`${groupPrefix}`, { method: 'DELETE', body: { media: mediaUuids } })
	},
}
